export default "__VITE_ASSET__CFjeSU77__"